import { render, staticRenderFns } from "./manageWellActivityTemplate.vue?vue&type=template&id=a4c98bbc&scoped=true"
import script from "./manageWellActivityTemplate.vue?vue&type=script&lang=ts"
export * from "./manageWellActivityTemplate.vue?vue&type=script&lang=ts"
import style0 from "./manageWellActivityTemplate.vue?vue&type=style&index=0&id=a4c98bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c98bbc",
  null
  
)

export default component.exports